import ApiConstants from "../../Constants/ApiConstant";
import { apiDelete, apiGet, apiPost, apiPut } from "../../Services/ApiService";

export const getMenuDetailsAPI = (routeSource,  callBack) => {
    return async () => {
      try {
        await apiGet(`${ApiConstants.menuUrl}`)
        // await apiGet(`${ApiConstants.menuUrl}?route_source=${routeSource}`)
          .then((response) => {
            callBack && callBack(response?.data, response?.data);
          })
          .catch((err) => {
            console.log("get Menu api err===-=>>>:", err);
            throw err;
          });
      } catch (err) {
        console.log("get Menu api err", err);
        throw err;
      }
    };
};

  export const addMenuDetailsAPI = (data, callBack) => {
    return async () => {
      try {
        await apiPost(ApiConstants.menuUrl, data)
          .then((response) => {
            callBack && callBack(response?.data, response?.data);
          })
          .catch((err) => {
            console.log("add product category api err===-=>>>:", err);
            throw err;
          });
      } catch (err) {
        console.log("add product category api err:", err);
        throw err;
      }
    };
  };

  export const updateMenuDetailsAPI = (data, callBack) => {
    return async () => {
      try {
        await apiPut(ApiConstants.menuUrl, data)
          .then((response) => {
            callBack && callBack(response?.data, response?.data);
          })
          .catch((err) => {
            console.log("update menu api err===-=>>>:", err);
            throw err;
          });
      } catch (err) {
        console.log("update menu api err:", err);
        throw err;
      }
    };
  };

  export const deleteMenuDetailsAPI = (data, callBack) => {
    return async () => {
      try {
        await apiDelete(`${ApiConstants.menuUrl}/?menu_id=${data}`)
          .then((response) => {
            callBack && callBack(response?.data, response?.data);
          })
          .catch((err) => {
            console.log("delete product category api err===-=>>>:", err);
            throw err;
          });
      } catch (err) {
        console.log("delete product category api err:", err);
        throw err;
      }
    };
  };

  export const addContactUsUrl = (data, callBack) => {
    return async () => {
      try {
        await apiPost(ApiConstants.contactUsUrl, data)
          .then(response => {
            callBack && callBack(response?.data, response?.data);
          })
          .catch(err => {
          
            throw err;
          });
      } catch (err) {
      
        throw err;
      }
    };
  };